function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.054 11a4.054 4.054 0 100 8.108 4.054 4.054 0 000-8.108zm0 6.109a2.055 2.055 0 11.001-4.11 2.055 2.055 0 01-.001 4.11zM15.05 11a4.054 4.054 0 100 8.108 4.054 4.054 0 000-8.108zm0 6.109a2.054 2.054 0 110-4.108 2.054 2.054 0 010 4.108zM26.046 11a4.054 4.054 0 100 8.108 4.054 4.054 0 000-8.108zm0 6.109a2.054 2.054 0 110-4.108 2.054 2.054 0 010 4.108z"
})));